module.exports = __webpack_public_path__ + "img/52114111_L.10fecdf3.png";